import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1f0cbb17&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1f0cbb17&prod&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=1f0cbb17&prod&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0cbb17",
  null
  
)

export default component.exports